import React from 'react';

function Footer() {
    return (
        <footer className="container-fluid d-flex position-absolute bottom-0 bg-primary border-top">
                <span className="me-md-auto text-dark text-decoration-none">Copyright 2021 ©Alkemy-React-Challenge. All right reserved.</span>
                <a className="link-dark" href="https://superheroapi.com/">Superhero API</a>
        </footer>
    )
}

export default Footer;
